import React from 'react';
import { TableSortLabel } from '@mui/material';
import { StyledTableHeadCell } from './InventoryQueryTable.styles';
import type { WarehouseInventorySortField } from '../../../types/inventory';

export interface InventorySortableHeadCellProps {
  label: string;
  field: WarehouseInventorySortField;
  sortBy: WarehouseInventorySortField;
  sortOrder: 'asc' | 'desc';
  onSortChange: (field: WarehouseInventorySortField) => void;
}

export const InventorySortableHeadCell: React.FC<InventorySortableHeadCellProps> = ({
  label,
  field,
  sortBy,
  sortOrder,
  onSortChange,
}) => (
  <StyledTableHeadCell align="left">
    <TableSortLabel
      active={sortBy === field}
      direction={sortBy === field ? sortOrder : 'asc'}
      onClick={() => onSortChange(field)}
      sx={{
        flexDirection: 'row',
        justifyContent: 'flex-start',
        width: '100%',
      }}
    >
      {label}
    </TableSortLabel>
  </StyledTableHeadCell>
);
